import React from 'react';

const MobileNotification = () => {
  return (
    <div className="device-notification">
      <a className="device-notification--logo" href="#0">
        <img src="assets/img/logo.png" alt="Global" />
        <p>Mena Emad</p>
      </a>
      <p className="device-notification--message">Mena Emad Website has so much to offer that we must request you orient your device to portrait or find a larger screen. You won't be disappointed.</p>
    </div>
  );
};

export default MobileNotification; 